export default __webpack_public_path__ + "static/media/man-team-3.978d5c6e.avif";